// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { TaskFilterOptionsFragmentDoc, ProjectRoleDetailsFragmentDoc, ProjectStageProjectItemDetailFragmentDoc, ProjectScheduleDocumentDetailFragmentDoc, TaskStatusesFragmentDoc, TaskDetailPaneFragmentDoc, TaskDateEditabilityFragmentDoc, ResultingDelayResponseFragmentDoc, ScheduleSettingDetailsFragmentDoc, GlobalPhaseDetailsFragmentDoc, TaskScheduleDetailsFragmentDoc, SchedulePhaseDetailsFragmentDoc, RetrieveScheduleImpactFragmentDoc, InternalUserDetailFragmentDoc } from '../fragments/circularFragments.generated';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AllocateProjectItemsTaskModalQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  stage: Types.Stage;
}>;


export type AllocateProjectItemsTaskModalQuery = { __typename?: 'Query', scheduleTasks: Array<{ __typename?: 'ScheduleTask', status: Types.TaskStatus, id: string, name: string, assignee?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string, enableClickToPay: boolean } | null | undefined, projectItems: Array<{ __typename?: 'ProjectItem', id: string }> }> };

export type AllocateProjectItemsFragment = { __typename?: 'ProjectItem', id: string, displayName: string, totalCostInCents: number, task?: { __typename?: 'Task', id: string, name: string, projectItems: Array<{ __typename?: 'ProjectItem', id: string }> } | null | undefined };

export const AllocateProjectItemsFragmentDoc = gql`
    fragment AllocateProjectItems on ProjectItem {
  id
  displayName
  totalCostInCents
  task {
    ...Named
    projectItems {
      id
    }
  }
}
    ${NamedFragmentDoc}`;
export const AllocateProjectItemsTaskModalDocument = gql`
    query AllocateProjectItemsTaskModal($projectId: ID!, $stage: Stage!) {
  scheduleTasks(
    filter: {scheduleParent: [$projectId], stage: [$stage]}
    first: 100000
  ) {
    ...TaskFilterOptions
    status
  }
}
    ${TaskFilterOptionsFragmentDoc}`;

/**
 * __useAllocateProjectItemsTaskModalQuery__
 *
 * To run a query within a React component, call `useAllocateProjectItemsTaskModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllocateProjectItemsTaskModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocateProjectItemsTaskModalQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      stage: // value for 'stage'
 *   },
 * });
 */
export function useAllocateProjectItemsTaskModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AllocateProjectItemsTaskModalQuery, AllocateProjectItemsTaskModalQueryVariables> & ({ variables: AllocateProjectItemsTaskModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllocateProjectItemsTaskModalQuery, AllocateProjectItemsTaskModalQueryVariables>(AllocateProjectItemsTaskModalDocument, options);
      }
export function useAllocateProjectItemsTaskModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllocateProjectItemsTaskModalQuery, AllocateProjectItemsTaskModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllocateProjectItemsTaskModalQuery, AllocateProjectItemsTaskModalQueryVariables>(AllocateProjectItemsTaskModalDocument, options);
        }
export function useAllocateProjectItemsTaskModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AllocateProjectItemsTaskModalQuery, AllocateProjectItemsTaskModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AllocateProjectItemsTaskModalQuery, AllocateProjectItemsTaskModalQueryVariables>(AllocateProjectItemsTaskModalDocument, options);
        }
export type AllocateProjectItemsTaskModalQueryHookResult = ReturnType<typeof useAllocateProjectItemsTaskModalQuery>;
export type AllocateProjectItemsTaskModalLazyQueryHookResult = ReturnType<typeof useAllocateProjectItemsTaskModalLazyQuery>;
export type AllocateProjectItemsTaskModalSuspenseQueryHookResult = ReturnType<typeof useAllocateProjectItemsTaskModalSuspenseQuery>;
export type AllocateProjectItemsTaskModalQueryResult = Apollo.QueryResult<AllocateProjectItemsTaskModalQuery, AllocateProjectItemsTaskModalQueryVariables>;